import React from 'react';
import {Button} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import TiersPayantStatutBadge from '../../../components/TiersPayantStatutBadge';

const AlertListRow = ({entry, showDaysOverdue = false}) => {
    const navigate = useNavigate();
    const goToDossier = () => navigate(`/tiers-payant/comment/${entry.id}`);
    const days = entry.daysSinceInvoice;

    return (
        <div className="d-flex align-items-center py-2 border-bottom" style={{gap: '0.75rem'}}>
            <div style={{flex: 2, minWidth: 0}}>
                <div className="text-truncate">
                    <strong>{entry.patient}</strong>
                </div>
                <div className="text-muted small text-truncate">
                    Facture {entry.invoiceNumber}
                </div>
            </div>
            <div style={{flex: 1, minWidth: 0}}>
                <TiersPayantStatutBadge status={entry.status} />
            </div>
            <div style={{width: 110, textAlign: 'center'}}>
                {showDaysOverdue && days != null ? (
                    <span
                        className="badge"
                        style={{backgroundColor: '#B02000', color: '#fff'}}
                    >
                        {days} jour{days > 1 ? 's' : ''}
                    </span>
                ) : null}
            </div>
            <div style={{width: 90}} className="text-end">
                <Button variant="outline-primary" size="sm" onClick={goToDossier}>
                    Voir
                </Button>
            </div>
        </div>
    );
};

export default AlertListRow;
